import React from "react"
import styled from "styled-components"

export const Disclaimer = styled.section`
    background-color: #f8f8f8;
    h4 {
        margin-bottom: 8px;
        font-weight: 600 !important;
        text-align: center;
    }
    p {
        margin-bottom: 15px;
    }
    h4,
    p,
    ul li,
    strong {
        font-size: 14pt !important;
        line-height: 20pt !important;
        width: 100% !important;
    }
    ul {
        margin-bottom: 15px;
        li {
            margin-left: 15px !important;
            margin-bottom: 0 !important;
            list-style: disc !important;
        }
    }
    table {
        margin-bottom: 8px;
        border: 2px solid #767676;
        border-radius: 8px;
        border-collapse: separate;
        border-spacing: 0;
        td {
            padding: 8px;
            vertical-align: middle;
            strong {
                font-weight: 600;
            }
        }
        tr {
            th,
            td {
                width: 50%;
                font-size: 14pt !important;
                line-height: 20pt !important;
                color: #103110 !important;
                background: none !important;
                
                &:first-child {
                    border-right: 2px solid #767676;
                }
            }
            th {
                &:last-child {
                    border-top-right-radius: 8px;
                }
                &:first-child {
                    border-top-left-radius: 8px;
                }
            }
            strong {
                color: #103110 !important;
            }
        }
        thead tr {
            th {
                padding: 18px 8px;
                font-weight: 600;
                border-left: 0 !important;
            }
        }
        tbody tr {
            border-top: 2px solid #767676;
            td {
                border-top: 2px solid #767676;
            }
        }
    }
}
`

const StDisclaimer = () => {
    return (
        <Disclaimer>
            <div className="container container--grid">
                <div className="container__row">
                    <h4 className="text-center">IMPORTANT: This is a short-term, limited-duration policy, NOT comprehensive health coverage</h4>
                    <p className="text-center">
                        This is a temporary limited policy that has fewer benefits and Federal protections than other types of health
                        insurance options, like those on HealthCare.gov.
                    </p>
                    <table data-qa="st-disclaimer-table">
                        <thead>
                            <tr>
                                <th className="text-center">This policy</th>
                                <th className="text-center">Insurance on HealthCare.gov</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                <strong>Might not cover you</strong> due to preexisting health conditions like diabetes, cancer, stroke,
                                arthritis, heart disease, mental health &amp; substance use disorders
                                </td>
                                <td>Can't deny you coverage due to preexisting health conditions</td>
                            </tr>
                            <tr>
                                <td>
                                <strong>Might not cover</strong> things like prescription drugs, preventive screenings, maternity care,
                                emergency services, hospitalization, pediatric care, physical therapy &amp; more
                                </td>
                                <td>Covers all essential health benefits</td>
                            </tr>
                            <tr>
                                <td>Might have <strong>no limit on what you pay</strong> out-of-pocket for care</td>
                                <td>
                                Protects you with limits on what you pay each year out-of-pocket for essential health benefits
                                </td>
                            </tr>
                            <tr>
                                <td>
                                You <strong>won't qualify</strong> for Federal financial help to pay premiums &amp; out-of-pocket costs
                                </td>
                                <td>Many people qualify for Federal financial help</td>
                            </tr>
                            <tr>
                                <td><strong>Doesn't have to meet</strong> Federal standards for comprehensive health coverage</td>
                                <td>All plans must meed Federal standards</td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="mb-0"><strong>Looking for comprehensive health insurance?</strong></p>
                    <ul className="pl-0">
                        <li>
                        <strong>Visit HealthCare.gov</strong> or call <strong>1-800-318-2596</strong> (TTY: 1-855-889-4325) to find
                        health coverage options.
                        </li>
                        <li>
                        To find out if you can get health insurance through your job, or a family member's job, contact the
                        employer.
                        </li>
                    </ul>
                    <p className="mb-0"><strong>Questions about this policy?</strong></p>
                    <p>
                        For questions or complaints about this policy, contact your State Department of Insurance. Find their number
                        on the National Association of Insurance Commissioners' website (naic.org) under "Insurance Departments."
                    </p>
                </div>
            </div>
        </Disclaimer>
    )
};

export default StDisclaimer;
